import React from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Header from "./Header";
import Footer from "./Footer";
import PageTransition from "./PageTransition";
import AnnouncementBar from "../common/AnnouncementBar";
import ScrollProgress from "../common/ScrollProgress";
import WhatsAppButton from "../common/WhatsAppButton";
import BackToTop from "../common/BackToTop";
import CustomCursor from "../common/CustomCursor";

/**
 * Layout — shared chrome around every route: skip link, announcement bar,
 * header, animated page transition, footer, and floating utilities.
 */
export default function Layout({ children }) {
  const location = useLocation();

  return (
    <>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <ScrollProgress />
      <CustomCursor />
      <AnnouncementBar />
      <Header />
      <main id="main-content">
        <AnimatePresence mode="wait">
          <PageTransition key={location.pathname}>{children}</PageTransition>
        </AnimatePresence>
      </main>
      <Footer />
      <WhatsAppButton />
      <BackToTop />
    </>
  );
}
